// extracted by mini-css-extract-plugin
export var image = "SWXBC";
export var root = "dY5ts";
export var scrollIndicator = "Wg8hM";
export var wave = "vFFO9";